import * as XLSX from 'xlsx';
import { GRUPLAR } from './fiyatListesiApi';
import { katla, trFiltre } from './teklifTheme';

export { katla, trFiltre };

export { GRUPLAR };

export const BIRIMLER = [
  'Adet',
  'Metre',
  'm²',
  'Kg',
  'Km',
  'Litre',
  'Set',
  'Takım',
  'Sistem',
  'Paket',
  'Saat',
  'Gün',
  'Kişi/Gün',
  'Götürü',
  '%'
];
export const PARA_BIRIMLERI = ['TRY', 'USD', 'EUR', 'GBP'];
const SUTUNLAR = ['Malzeme Tanımı', 'Birim', 'Fiyat', 'Para Birimi'];
const MAKS_SATIR = 5000;
// Müşteri dosyalarındaki kısaltmalar
const BIRIM_ESLER = {
  M: 'Metre',
  MT: 'Metre',
  M2: 'm²',
  LT: 'Litre',
  KISIGUN: 'Kişi/Gün',
  ADAMGUN: 'Kişi/Gün',
  TK: 'Takım'
};

export const kalemAnahtari = (grup, tanim) => `${grup}|${katla(tanim)}`;

/** "1.250,50", "1250.5", 1250.5 → 1250.5; geçersizse NaN. */
export const trSayi = (v) => {
  if (typeof v === 'number') return v;
  let s = String(v ?? '')
    .trim()
    .replace(/\s/g, '')
    .replace(/[₺$€£]|TL/gi, '');
  if (!s) return NaN;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  return /^-?\d+(\.\d+)?$/.test(s) ? Number(s) : NaN;
};

const nf = new Intl.NumberFormat('tr-TR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
export const trFormat = (n) =>
  n === '' || n === null || n === undefined || Number.isNaN(Number(n))
    ? ''
    : nf.format(n);

const grupKoduExcel = (metin) => {
  const f = katla(metin);
  const g = GRUPLAR.find((x) => katla(x.excel) === f);
  return g ? g.kod : null;
};

const bosMu = (v) => String(v ?? '').trim() === '';

const sade = (v) => katla(v).replace(/[.\s/-]/g, '');
export const birimBul = (v) => {
  const k = sade(v);
  return k
    ? BIRIMLER.find((b) => sade(b) === k) || BIRIM_ESLER[k] || null
    : null;
};
const pbBul = (v) => {
  const k = katla(v) === 'TL' ? 'TRY' : katla(v);
  return PARA_BIRIMLERI.find((p) => p === k) || null;
};

/** Dosyayı satır dizisine çevirir; "Kalemler" sayfası yoksa ilk sayfa okunur. */
export const dosyaOku = (dosya) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      try {
        const wb = XLSX.read(new Uint8Array(r.result), { type: 'array' });
        const ws = wb.Sheets.Kalemler || wb.Sheets[wb.SheetNames[0]];
        resolve(
          XLSX.utils.sheet_to_json(ws, {
            header: 1,
            defval: '',
            raw: true,
            blankrows: false
          })
        );
      } catch (e) {
        reject(e);
      }
    };
    r.onerror = () => reject(r.error);
    r.readAsArrayBuffer(dosya);
  });

/** Şablon kuralı: kalem, üstündeki en yakın başlık satırının (MALZEME / İŞÇİLİK / DİĞER BEDELLER) grubuna aittir. */
export const excelOku = (aoa) => {
  const sonuc = { satirlar: [], genelHata: null };
  if (aoa.length > MAKS_SATIR + 1) {
    sonuc.genelHata = `Dosyada ${MAKS_SATIR.toLocaleString('tr-TR')}'den fazla satır var. Dosyayı bölerek yükleyin.`;
    return sonuc;
  }
  const bas = aoa.findIndex((r) => katla(r[0]) === 'MALZEME TANIMI');
  if (bas < 0) {
    sonuc.genelHata =
      'Dosya şablona uymuyor: "Malzeme Tanımı" başlıklı sütun bulunamadı. Şablonu indirip onunla doldurun.';
    return sonuc;
  }
  const gelen = aoa[bas].slice(0, SUTUNLAR.length).map(katla);
  const farkli = SUTUNLAR.filter((s, i) => gelen[i] !== katla(s));
  if (farkli.length) {
    sonuc.genelHata = `Sütun başlıkları şablondan farklı (${farkli.join(', ')}). Güncel şablonu indirip onunla doldurun.`;
    return sonuc;
  }

  // Başlığın üstündeki "tüm satırlara uygula" seçimleri; satırda boş bırakılan hücreye bunlar yazılır
  let varsayilanBirim = null;
  let varsayilanPb = null;
  for (let i = 0; i < bas; i++) {
    varsayilanBirim = varsayilanBirim || birimBul(aoa[i]?.[1]);
    varsayilanPb = varsayilanPb || pbBul(aoa[i]?.[3]);
  }

  let grup = null;
  const ilkGorulen = new Map();
  for (let i = bas + 1; i < aoa.length; i++) {
    const r = aoa[i] || [];
    const h = [0, 1, 2, 3].map((c) =>
      r[c] === undefined || r[c] === null ? '' : r[c]
    );
    // Şablonda birim ve para birimi hücreleri formülle dolu; tanım ve fiyat yoksa satır boştur
    if (bosMu(h[0]) && bosMu(h[2])) continue;

    const g = grupKoduExcel(h[0]);
    if (g && h.slice(1).every(bosMu)) {
      grup = g;
      continue;
    }

    const s = { satirNo: i + 1, grup, tanim: String(h[0]).trim(), hatalar: [] };
    if (!grup)
      s.hatalar.push(
        'Ana başlık (MALZEME, İŞÇİLİK, DİĞER BEDELLER) altında değil.'
      );
    if (!s.tanim) s.hatalar.push('Malzeme tanımı boş.');
    else if (s.tanim.length > 250)
      s.hatalar.push('Tanım 250 karakterden uzun.');

    const birim = bosMu(h[1]) ? varsayilanBirim : birimBul(h[1]);
    if (!birim)
      s.hatalar.push(
        bosMu(h[1]) ? 'Birim boş.' : `Birim listede yok: "${h[1]}".`
      );
    else s.birim = birim;

    const fiyat = trSayi(h[2]);
    if (bosMu(h[2])) s.hatalar.push('Fiyat boş.');
    else if (Number.isNaN(fiyat) || fiyat < 0)
      s.hatalar.push(`Fiyat geçersiz: "${h[2]}".`);
    else s.fiyat = Math.round(fiyat * 100) / 100;

    const pb = bosMu(h[3]) ? varsayilanPb : pbBul(h[3]);
    if (!pb)
      s.hatalar.push(
        bosMu(h[3]) ? 'Para birimi boş.' : `Para birimi listede yok: "${h[3]}".`
      );
    else s.pb = pb;

    if (grup && s.tanim) {
      const a = kalemAnahtari(grup, s.tanim);
      if (ilkGorulen.has(a))
        s.hatalar.push(
          `Aynı başlıkta tekrar ediyor (satır ${ilkGorulen.get(a)}).`
        );
      else ilkGorulen.set(a, s.satirNo);
    }
    sonuc.satirlar.push(s);
  }
  if (!sonuc.satirlar.length)
    sonuc.genelHata = 'Dosyada yüklenecek kalem bulunamadı.';
  return sonuc;
};

/** Okunan satırları ekrandaki kalemlerle eşleştirir: yeni / guncel / ayni / hata. */
export const karsilastir = (satirlar, kalemler) => {
  const mevcut = new Map(
    kalemler.map((k) => [kalemAnahtari(k.Grup, k.Tanim), k])
  );
  return satirlar.map((s) => {
    if (s.hatalar.length) return { ...s, durum: 'hata' };
    const m = mevcut.get(kalemAnahtari(s.grup, s.tanim));
    if (!m) return { ...s, durum: 'yeni' };
    const farklar = [];
    if (m.Birim !== s.birim) farklar.push(['Birim', m.Birim, s.birim]);
    if (Number(m.Fiyat) !== s.fiyat || m.ParaBirimi !== s.pb)
      farklar.push([
        'Fiyat',
        `${trFormat(m.Fiyat)} ${m.ParaBirimi}`,
        `${trFormat(s.fiyat)} ${s.pb}`
      ]);
    if (!m.Aktif) farklar.push(['Durum', 'Pasif', 'Aktif']);
    return {
      ...s,
      anahtar: m._anahtar,
      farklar,
      durum: farklar.length ? 'guncel' : 'ayni'
    };
  });
};

const KOYU = 'FF1E293B';
const TURUNCU = 'FFFF9800';
const TURUNCU_ACIK = 'FFFFF3E0';
const CIZGI = 'FFE2E8F0';
const ince = { style: 'thin', color: { argb: CIZGI } };
const kenar = { top: ince, left: ince, bottom: ince, right: ince };

const listeKurali = (baslik, degerler, prompt = 'Açılır listeden seçin.') => ({
  type: 'list',
  allowBlank: true,
  formulae: [`"${degerler.join(',')}"`],
  showErrorMessage: true,
  errorStyle: 'stop',
  errorTitle: baslik,
  error: `Listeden seçin: ${degerler.join(', ')}`,
  showInputMessage: true,
  promptTitle: baslik,
  prompt
});

const enCok = (degerler, yedek) => {
  const n = new Map();
  degerler.forEach((d) => n.set(d, (n.get(d) || 0) + 1));
  return [...n].sort((x, y) => y[1] - x[1])[0]?.[0] || yedek;
};

/**
 * Şablon ve dışa aktarma aynı dosyayı üretir; dışa aktarılan dosya düzenlenip geri yüklenebilir.
 * exceljs büyük; yalnız ihtiyaç anında yükleniyor.
 */
export const excelOlustur = async (kalemler = []) => {
  const { default: ExcelJS } = await import('exceljs');
  const wb = new ExcelJS.Workbook();
  wb.creator = 'Apollo';

  const ws = wb.addWorksheet('Kalemler', {
    views: [{ state: 'frozen', ySplit: 2 }]
  });
  ws.columns = [{ width: 62 }, { width: 13 }, { width: 15 }, { width: 13 }];

  // 1. satır: seçilen birim / para birimi alttaki satırlara formülle gelir
  const vBirim = enCok(
    kalemler.map((k) => k.Birim),
    'Adet'
  );
  const vPb = enCok(
    kalemler.map((k) => k.ParaBirimi),
    'TRY'
  );
  const ust = ws.getRow(1);
  ust.values = ['Tüm satırlara uygula ▸', vBirim, '', vPb];
  ust.height = 24;
  ust.getCell(1).font = { italic: true, color: { argb: 'FF64748B' } };
  ust.getCell(1).alignment = { vertical: 'middle', horizontal: 'right' };
  [2, 4].forEach((i) => {
    const c = ust.getCell(i);
    const m = { style: 'medium', color: { argb: TURUNCU } };
    c.font = { bold: true, color: { argb: 'FFE65100' } };
    c.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: TURUNCU_ACIK }
    };
    c.alignment = { vertical: 'middle', horizontal: 'center' };
    c.border = { top: m, left: m, bottom: m, right: m };
  });

  const h = ws.getRow(2);
  h.values = SUTUNLAR;
  h.height = 24;
  h.eachCell((c) => {
    c.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: KOYU } };
    c.alignment = {
      vertical: 'middle',
      horizontal: c.col === 1 ? 'left' : 'center'
    };
    c.border = kenar;
  });

  const birimHucre = (d) =>
    d === vBirim ? { formula: '$B$1', result: vBirim } : d;
  const pbHucre = (d) => (d === vPb ? { formula: '$D$1', result: vPb } : d);
  const bosSatir = { MALZEME: 15, ISCILIK: 10, DIGER: 10 };
  GRUPLAR.forEach((g) => {
    const r = ws.addRow([g.excel]);
    ws.mergeCells(r.number, 1, r.number, 4);
    r.height = 22;
    const c = r.getCell(1);
    c.font = { bold: true, color: { argb: 'FFE65100' } };
    c.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: TURUNCU_ACIK }
    };
    c.alignment = { vertical: 'middle' };
    c.border = {
      top: { style: 'medium', color: { argb: TURUNCU } },
      bottom: ince
    };

    const grupKalemleri = kalemler.filter((k) => k.Grup === g.kod);
    const satirlar = kalemler.length
      ? grupKalemleri
      : Array(bosSatir[g.kod]).fill(null);
    satirlar.forEach((k) => {
      const d = ws.addRow(
        k
          ? [
              k.Tanim,
              birimHucre(k.Birim),
              Number(k.Fiyat),
              pbHucre(k.ParaBirimi)
            ]
          : ['', birimHucre(vBirim), null, pbHucre(vPb)]
      );
      for (let i = 1; i <= 4; i++) d.getCell(i).border = kenar;
      [2, 4].forEach((i) => {
        d.getCell(i).alignment = { horizontal: 'center' };
      });
      d.getCell(3).numFmt = '#,##0.00';
    });
  });

  // Tek ve çakışmasız aralık; hücre hücre yazılırsa Excel kuralları "onarıp" siliyor
  const tumu =
    'Seçtiğiniz değer bu sütundaki tüm satırlara gelir. Farklı olanı satırda ayrıca seçebilirsiniz.';
  ws.dataValidations.add(
    'B1',
    listeKurali('Birim (tüm satırlar)', BIRIMLER, tumu)
  );
  ws.dataValidations.add(
    'D1',
    listeKurali('Para Birimi (tüm satırlar)', PARA_BIRIMLERI, tumu)
  );
  ws.dataValidations.add('B3:B5000', listeKurali('Birim', BIRIMLER));
  ws.dataValidations.add('C3:C5000', {
    type: 'decimal',
    operator: 'greaterThanOrEqual',
    formulae: [0],
    allowBlank: true,
    showErrorMessage: true,
    errorStyle: 'stop',
    errorTitle: 'Fiyat',
    error: 'Fiyat 0 veya daha büyük bir sayı olmalı.'
  });
  ws.dataValidations.add(
    'D3:D5000',
    listeKurali('Para Birimi', PARA_BIRIMLERI)
  );

  const aciklama = wb.addWorksheet('Nasıl Doldurulur');
  aciklama.getColumn(1).width = 4;
  aciklama.getColumn(2).width = 100;
  aciklama.addRow(['', 'Teklif Kalemleri – Excel Şablonu']).getCell(2).font = {
    bold: true,
    size: 14,
    color: { argb: KOYU }
  };
  aciklama.addRow([]);
  [
    'Kalemleri "Kalemler" sayfasında, ilgili ana başlığın (MALZEME, İŞÇİLİK, DİĞER BEDELLER) altındaki satırlara yazın.',
    'Ana başlık satırlarını silmeyin, adlarını değiştirmeyin. Bir kalem hangi başlığın altındaysa o gruba kaydedilir.',
    'Başlığın altına yeni satır eklemek için satıra sağ tıklayıp "Ekle" deyin. Boş satırlar yükleme sırasında atlanır.',
    'Malzeme Tanımı zorunludur, en fazla 250 karakter. Aynı başlık altında aynı tanım iki kez yazılmamalı.',
    'En üstteki turuncu hücrelerden Birim ve Para Birimi seçin; seçtiğiniz değer tüm satırlara gelir.',
    'Farklı olan satırda Birim veya Para Birimi hücresinden ayrıca seçim yapın. Boş bırakılan hücre için üstteki seçim geçerlidir.',
    'Fiyat: birim fiyat, KDV hariç.',
    'Listedeki bir kalemle aynı başlık ve aynı tanıma sahip satır o kalemi günceller; diğerleri yeni kalem olarak eklenir.',
    'Sütunların sırasını ve başlıklarını (2. satır) değiştirmeyin.'
  ].forEach((k, i) => {
    aciklama.addRow(['', `${i + 1}. ${k}`]).getCell(2).alignment = {
      wrapText: true,
      vertical: 'top'
    };
  });

  const veri = await wb.xlsx.writeBuffer();
  return new Blob([veri], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
};

export const blobIndir = (blob, dosyaAdi) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dosyaAdi;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 5000);
};
